import React, { useEffect, useState } from 'react';
import ItemPriceTable from './ItemPriceTable';
import masterDataService from '../../service/masterData.service';

const ItemPrice = (props) => {
  const [priceLists, setPriceLists] = useState([]);
  const [rows, setRows] = useState([]);
  const { selectedValues } = props;

  useEffect(() => {
    const timer = setTimeout(() => {
      getPriceLists();
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const getPriceLists = () => {
    masterDataService.priceListToForm().then((data) => {
      setPriceLists(data);
    });
  };

  useEffect(() => {
    if (!selectedValues && priceLists.length === 0) return setRows([]);

    const newRows = priceLists.map((pl) => {
      const existingPrice = selectedValues?.itemPrice?.find((ip) => ip.priceListId === pl.id);
      return {
        ...pl,
        price: existingPrice?.price ?? null,
        pricelistItemId: existingPrice?.id ?? null,
      };
    });
    setRows(newRows);
  }, [selectedValues, priceLists]);

  return rows.length > 0 && <ItemPriceTable {...props} rows={rows} />;
};

export default ItemPrice;
